// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bring-business-card .dashboard-card-row{justify-content:space-between;align-items:center}.bring-business-card-text{flex:auto !important}.bring-business-card-cta-container{flex:1}@media (max-width: 767.98px){.bring-business-card-cta-container{text-align:center}}\n", ""]);
// Exports
module.exports = exports;
